// extracted by mini-css-extract-plugin
export default {"infoProyect":"Info_infoProyect__RsaDf","info2Proyect":"Info_info2Proyect__7yjSJ","imgProyect":"Info_imgProyect__7x9rt"};